import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { InfoCode } from 'src/app/models/domain';
import { DesignService, InfoCodesService } from 'src/app/state';

@Component({
  selector: 'em-info-codes',
  templateUrl: './info-codes.component.html',
  standalone: false,
})
export class InfoCodesComponent implements OnInit, OnDestroy {
  @ViewChild('longTextTemplate', { static: true })
  private readonly longTextTemplate!: TemplateRef<{ $implicit: string }>;

  public subscriptions = new Subscription();

  public infoCodes$ = this.infoCodesService.infoCodes$;
  public error$ = this.infoCodesService.error$;
  public loading$ = this.infoCodesService.loading$;

  public constructor(
    private readonly infoCodesService: InfoCodesService,
    private readonly designService: DesignService,
    private readonly modalService: NzModalService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(switchMap((id) => this.infoCodesService.loadByDesignId(id)))
        .subscribe()
    );
  }

  public displayLongText(infoCode: InfoCode) {
    const modal = this.modalService.create({
      nzClosable: true,
      nzContent: this.longTextTemplate,
      nzData: infoCode.longText,
      nzFooter: [
        {
          label: 'Close',
          onClick: () => {
            modal.destroy();
          },
        },
      ],
      nzMaskClosable: true,
      nzTitle: 'Long text',
      nzWidth: '80%',
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
